import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./home/home.module').then((m) => m.HomeModule),
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./login/login.module').then((m) => m.LoginModule),
  },
  {
    path: 'recovery-pass/:token',
    loadChildren: () =>
      import('./login/pages/olvide-contrasenia/olvide-contrasenia.module').then(
        (m) => m.OlvideContraseniaPageModule
      ),
  },
  {
    path: 'pagos',
    loadChildren: () =>
      import('./pagos/pagos.module').then((m) => m.PagosModule),
  },
  {
    path: 'publicidad',
    loadChildren: () =>
      import('./publicidad/publicidad.module').then((m) => m.PublicidadModule),
  },
  {
    path: 'edo-cuenta',
    loadChildren: () =>
      import('./edo-cuenta/edo-cuenta.module').then((m) => m.EdoCuentaModule),
  },
  {
    path: 'terms',
    loadChildren: () => import('./terms/terms.module').then( m => m.TermsPageModule)
  },
  {
    path: 'product-detail/:id',
    loadChildren: () => import('./product-detail/product-detail.module').then( m => m.ProductDetailPageModule)
  },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class GeneralRoutingModule {}
